<template>
  <div class="icon-info-cards">
    <div
      v-for="(infoCard, index) in infoCards"
      :key="index"
      class="icon-info-cards__item"
    >
      <div
        class="icon-info-cards__item__icon"
        :class="{
          'icon-info-cards__item__icon--colored': infoCard.color ?? true,
        }"
      >
        <i :class="infoCard.icon" />
      </div>
      <div class="icon-info-cards__item__content">
        <div
          class="icon-info-cards__item__content__title"
          v-html="infoCard.title"
        />
        <div
          class="icon-info-cards__item__content__description"
          v-html="infoCard.description"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  infoCards: {
    color?: boolean;
    description: string;
    icon: string;
    title: string;
  }[];
}>();
</script>

<style lang="postcss">
.icon-info-cards {
  @apply grid grid-cols-1 gap-6 md:grid-cols-2;

  &__item {
    @apply flex gap-4;

    &__icon {
      @apply flex size-16 min-w-16 items-center justify-center rounded-full bg-gray-50;

      i {
        @apply text-2xl text-primary-950;
      }

      &--colored {
        @apply bg-primary-50;
      }
    }

    &__content {
      @apply mt-2 text-gray-700;

      &__title {
        @apply font-semibold;
      }
      &__description {
        a {
          @apply text-primary-700;
          &:hover {
            @apply text-primary-500;
          }
        }
      }
    }
  }
}
</style>
